import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=08f5e3f2&scoped=true&lang=html&"
import script from "./DropDown.vue?vue&type=script&lang=coffee&"
export * from "./DropDown.vue?vue&type=script&lang=coffee&"
import style0 from "./DropDown.vue?vue&type=style&index=0&id=08f5e3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5e3f2",
  null
  
)

component.options.__file = "DropDown.vue"
export default component.exports